<template>
  <div>
    <div class="swiper" ref="swiper">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div class="swiper-slide slide1">
          <div class="inner">
            <h4 class="subtitle">{{ $t('heroSlider.slide1.subtitle') }}</h4>
            <h1 class="title" v-html="$t('heroSlider.slide1.title')"></h1>
						<!--<BtnPrimary text="WTS 체험하기" />-->
          </div>
        </div>
        <div class="swiper-slide slide2">
          <div class="inner">
            <h4 class="subtitle">{{ $t('heroSlider.slide2.subtitle') }}</h4>
            <h1 class="title" v-html="$t('heroSlider.slide2.title')"></h1>
						<BtnPrimary text="Learn more" @click="goAts" />
          </div>
        </div>
        <div class="swiper-slide slide3">
          <div class="inner">
            <h4 class="subtitle">{{ $t('heroSlider.slide3.subtitle') }}</h4>
            <h1 class="title" v-html="$t('heroSlider.slide3.title')"></h1>
						<!--<BtnPrimary text="모의투자 체험하기" />-->
          </div>
        </div>
      </div>
      <!-- If we need pagination -->
      <div class="swiper-pagination"></div>

      <!-- If we need navigation buttons -->
      <!-- <div class="swiper-button-prev"></div> -->
      <!-- <div class="swiper-button-next"></div> -->

      <!-- If we need scrollbar -->
      <!-- <div class="swiper-scrollbar"></div> -->
    </div>
  </div>
</template>

<script>
import Swiper, { Pagination, Autoplay } from 'swiper';
import 'swiper/css';
// import 'swiper/css/navigation';
import 'swiper/css/pagination';
import BtnPrimary from './BtnPrimary.vue';

export default {
  components: { BtnPrimary },
  name: 'HeroSlider',

  data() {
    return {};
  },

  mounted() {
    new Swiper(this.$refs.swiper, {
      // configure Swiper to use modules
      modules: [Pagination, Autoplay],
      // Optional parameters
      loop: true,
      // autoplay: {
      //   delay: 2500,
      // },
      // If we need pagination
      pagination: {
        clickable: true,
        el: '.swiper-pagination',
      },
    });
  },

  methods: {
    goAts() {
      this.$router.push('autotrading')
    }
  },
};
</script>

<style lang="scss" scoped>
.swiper {
  /* max-width: 100; */
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}
.swiper-slide {
  display: flex;
  align-items: center;
  /* justify-content: center; */
  width: 100%;
  height: 600px;
  /* border: 1px solid rgba(255, 255, 255, 0.2); */
  /* background-color: transparent; */
  /* border: 1px solid gray; */
	.inner {
    max-width: 1240px;
		padding: 0 20px;
    width: 100%;
    margin: 0 auto;
    color: white;
  }
	.subtitle {
		margin-bottom: 27px;
		opacity: 0.8;
	}
	.title {
		margin-bottom: 57px;
	}
	@media (max-width: $mobile) {
		height: 500px;
		.subtitle {
			font-size: 16px;
		}
			.title {
				font-size: 32px;
				margin-bottom: 27px;
			}
		}
&.slide1 {
    background: url('@/assets/images/hero-bg1.png') no-repeat;
    background-size: cover;
    background-position: center;
  }
  &.slide2 {
    background: url('@/assets/images/hero-bg2.png') no-repeat;
    background-size: cover;
    background-position: center;
  }
  &.slide3 {
    background: url('@/assets/images/hero-bg3.png') no-repeat;
    background-size: cover;
    background-position: center;
  }
  
}

</style>
